var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.27,
    height: 22.559,
    viewBox: "0 0 21.27 22.559",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "login",
    d: "M3.545,21.27A3.463,3.463,0,0,1,0,17.89V6.661A.918.918,0,0,1,.967,5.8a.917.917,0,0,1,.967.86V17.89a1.64,1.64,0,0,0,1.612,1.661H19.014a1.64,1.64,0,0,0,1.612-1.661V6.661a.973.973,0,0,1,1.933,0V17.89a3.463,3.463,0,0,1-3.545,3.38Zm6.7-8.314V3.3L6.742,6.808A.967.967,0,0,1,5.375,5.439L10.531.283a.967.967,0,0,1,1.368,0l5.156,5.156a.967.967,0,0,1-1.367,1.368L12.182,3.3v9.655c0,.32-.433.58-.967.58S10.247,13.276,10.247,12.956Z",
    transform: "translate(21.27) rotate(90)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.916786c99ba5f1fefd7bc46899928b52.svg";
export { ForwardRef as ReactComponent };